import { render } from "./PlusIcon.vue?vue&type=template&id=31d98eca&scoped=true"
import script from "./PlusIcon.vue?vue&type=script&lang=js"
export * from "./PlusIcon.vue?vue&type=script&lang=js"

import "./PlusIcon.vue?vue&type=style&index=0&id=31d98eca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d98eca"]])

export default __exports__